import * as Yup from "yup";
import checkout from "./form4";

const {
  formField4: {
    companyName,
    companyTaxId,
    taxAuthorities,
    numberSupplier,
    numberSupplierAuthority,
    period,

    firstTime,
    replaceNumber,

    fullName,
    signer,
    timeSign,
    certificate,
  },
} = checkout;

const validation4 = Yup.object().shape({
  [companyName.name]: Yup.string().required(companyName.errorMsg),
  [taxAuthorities.name]: Yup.string().required(taxAuthorities.errorMsg),
  [numberSupplier.name]: Yup.number().required(numberSupplier.errorMsg),
  [numberSupplierAuthority.name]: Yup.number().notRequired(numberSupplierAuthority.errorMsg),
  [period.name]: Yup.string().notRequired(period.errorMsg),
  [firstTime.name]: Yup.string().notRequired(firstTime.errorMsg),
  [replaceNumber.name]: Yup.number().notRequired(replaceNumber.errorMsg),

  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [certificate.name]: Yup.number().required(certificate.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),

  [companyTaxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, companyTaxId.invalidMsg)
    .required(companyTaxId.errorMsg),
});

export default validation4;
